import React, { useCallback, useEffect, useState } from "react";
import FlightBoard from "../../other/FlightBoard/FlightBoard";
import { executeMutation, executeQuery } from "../../../graphql/client";

// Member-facing Flights app (dashboard Apps tab). Read-only version
// of the admin Fly Scraper tab: the same FlightBoard (time filters,
// favorite regions, Best Price by Region, per-region tables) with
// NONE of the scraper controls, run schedule text, or logging — plus
// the round-trip banner so nobody mistakes the prices for one-way.
// Data comes from the graphql flyFlights query (#134 phase 1 — was
// the pendingJoinRequests REST ?type=flyFlights endpoint).

const FLY_FLIGHTS_QUERY = `
  query FlyFlights {
    flyFlights {
      flights {
        count
        lastModified
        items {
          origin
          destination
          price
          startDate
          endDate
          rawDates
          stops
          regionDestination
          updatedAt
        }
      }
      flightsError
    }
  }
`;

const FlightsApp = () => {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const data = await executeQuery(FLY_FLIGHTS_QUERY);
      const result = data?.flyFlights;
      if (result?.flightsError) {
        throw new Error(
          `No flight data available yet (${result.flightsError}).`
        );
      }
      setItems(result?.flights?.items || []);
    } catch (err) {
      setError(err.message || "Couldn't load flight deals.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // Fire-and-forget view tracking — the server dedupes to one row
  // per user per hour, so re-opens within the hour are one visit.
  useEffect(() => {
    try {
      executeMutation(`mutation { recordFlightView }`).catch(() => {});
    } catch (e) {
      // tracking must never break the page
    }
  }, []);

  return (
    <div>
      <div
        style={{
          background: "#eef7ee",
          border: "1px solid #b9dcb5",
          borderRadius: 8,
          padding: "14px 16px",
          margin: "0 0 12px",
          color: "#1f4f1d",
          fontWeight: 700,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        ✈️ All prices are round trip
      </div>

      {loading && items === null && (
        <p style={{ color: "#5b667a" }}>Loading flight deals…</p>
      )}
      {error && (
        <div
          style={{
            background: "#fdecea",
            border: "1px solid #e7b3ba",
            color: "#b00020",
            borderRadius: 8,
            padding: "10px 14px",
            marginBottom: 10,
            fontSize: 13,
          }}
        >
          {error}
        </div>
      )}
      {items && items.length === 0 && (
        <p style={{ color: "#5b667a" }}>
          No flight deals right now — check back soon!
        </p>
      )}
      {items && items.length > 0 && <FlightBoard items={items} />}
    </div>
  );
};

export default FlightsApp;
